// Account & security — profile, devices/sessions, two-factor, passwords.
// Sourced from specs/web-app.md (Account) and specs/cli.md §2 (device model).

import { IconDeviceLaptop, IconKey, IconShieldCheck, IconUserCircle } from "@tabler/icons-react";
import { DocSection, K, P, Points } from "../doc-ui";

export function AccountSecurityDoc() {
  return (
    <>
      <P>
        Everything about your own account lives on the <K>Account</K> page (in the menu at the
        bottom of the sidebar).
      </P>

      <DocSection icon={IconUserCircle} title="Profile">
        <P>
          Your display name is what teammates see in member lists and live presence. Edit it from
          the Account page any time.
        </P>
      </DocSection>

      <DocSection
        icon={IconDeviceLaptop}
        title="Devices & sessions"
        description="Every signed-in place is a session you can see and revoke."
      >
        <Points>
          <li>
            A desktop machine signed in with <K>cairn login</K> counts as one device — the CLI and
            all Obsidian vaults on it share that session.
          </li>
          <li>Each paired phone or tablet is its own device.</li>
          <li>Each browser you signed in from (like this one) is its own session.</li>
          <li>
            Lost a device? Revoke its session here and it stops syncing immediately. You can
            revoke any session except the one you're currently using.
          </li>
        </Points>
      </DocSection>

      <DocSection
        icon={IconShieldCheck}
        title="Two-factor authentication (TOTP)"
        description="A time-based code from an authenticator app, on top of your password."
      >
        <Points>
          <li>
            Enroll on the Account page: scan the QR with your authenticator app and confirm one
            code. From then on, sign-ins ask for a code.
          </li>
          <li>You can disable it there too (it asks for a current code).</li>
          <li>
            Locked out (lost phone)? A server admin can clear your TOTP so you can sign in and
            re-enroll — see <em>Invite &amp; manage users</em>.
          </li>
        </Points>
      </DocSection>

      <DocSection icon={IconKey} title="Passwords">
        <P>
          You set your password when you accept your account invite. If you forget it, ask an
          admin for a password-reset link — there's no self-service email reset, since a
          self-hosted server may not send email at all.
        </P>
      </DocSection>
    </>
  );
}
